module.exports = __webpack_public_path__ + "img/sichuanmalaniurou.8085cc91.jpg";